import React from 'react';
import Container from '../components/Container.jsx';
import SectionDivider from '../components/SectionDivider.jsx';
import QuoteBlock from '../components/QuoteBlock.jsx';
import FeatureHighlight from '../components/FeatureHighlight.jsx';

const values = [
  { icon: '🌱', title: 'Engagement local', description: 'Soutien aux producteurs et artisans de la région.' },
  { icon: '🤝', title: 'Qualité & transparence', description: 'Des ingrédients sélectionnés, des recettes authentiques.' },
  { icon: '🌍', title: 'Responsabilité', description: 'Démarche éco-responsable et circuits courts.' },
  { icon: '💡', title: 'Innovation', description: 'Créativité et renouvellement des saveurs.' },
];

const team = [
  { name: 'Yann Leclerc', role: 'Fondateur & Maître Boulanger', photo: '/images/team-yann.jpg' },
  { name: 'Sophie Martin', role: 'Responsable Pâtisserie', photo: '/images/team-sophie.jpg' },
  { name: 'Ali Benali', role: 'Chef de production', photo: '/images/team-ali.jpg' },
];

export function AboutPage() {
  return (
    <>
      <Container className="py-12 max-w-4xl">
        <h1 className="text-3xl font-heading font-bold text-primary mb-6 text-center">L’histoire d’Antic</h1>
        <QuoteBlock
          quote="Chez Antic, chaque pain raconte une histoire de passion, de terroir et d’excellence."
          author="Yann Leclerc, Fondateur"
        />
        <p className="text-lg text-text-secondary text-center mb-8">
          Fondée en 1998, la maison Antic perpétue la tradition boulangère française tout en innovant chaque jour. Notre équipe, passionnée et engagée, œuvre pour offrir des produits d’exception dans un esprit de convivialité et de partage.
        </p>
      </Container>
      <SectionDivider motif />
      <Container className="py-12">
        <h2 className="text-2xl font-heading font-bold text-primary mb-8 text-center">Nos valeurs</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {values.map((v) => (
            <FeatureHighlight key={v.title} {...v} />
          ))}
        </div>
      </Container>
      <SectionDivider />
      <Container className="py-12 max-w-4xl">
        <h2 className="text-2xl font-heading font-bold text-primary mb-8 text-center">Notre équipe</h2>
        <div className="flex flex-wrap justify-center gap-8">
          {team.map((member) => (
            <div key={member.name} className="flex flex-col items-center">
              <img src={member.photo} alt={member.name} className="w-28 h-28 rounded-full object-cover mb-2 shadow-md" />
              <div className="font-heading font-bold text-primary">{member.name}</div>
              <div className="text-text-secondary text-sm">{member.role}</div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
}

export default AboutPage;
